document.addEventListener('DOMContentLoaded', function () {
    // Получение значений по умолчанию
    let initialautoType
    let autoType
    if (document.querySelector('.product')) {
      initialautoType = document.querySelector('.product').dataset.type;  // Тип авто
      autoType = document.querySelector('.product').dataset.type;  // Тип авто
    } else {
      autoType = '5os'
    }
    
    const productContainer = document.querySelector('.product.config_container')
    const popupContainer = document.querySelector('.application_form__content.config_container')
    const lipTitleValues = document.querySelectorAll('.lip__title_value')
    const lipFields = document.querySelectorAll('.lip__field')
    const onlyDiamondsColors = document.querySelectorAll('.only_diamonds')

    // Базовый путь к изображениям 
    const basePath = "https://cdn.shopify.com/s/files/1/0790/9218/7414/files/";
    if (autoType == '7os' || autoType == 'pickup' || autoType == 'pickup2kabina'  || autoType == '2os' || autoType == 'van_maly' || autoType == 'electro' || autoType == 'custom' || autoType == 'electro_7os'  ) {
      autoType = '5os'
    }
    if (autoType == 'van_duzy' || autoType == 'camper' || autoType == 'tractor' ) {
      autoType = 'VAN'
    }
    // Функция для получения текущих значений опций
    function getCurrentOptions(container) {
      // Определение типа ковриков
      const matTypeElement = container.querySelector('.product-form__input[data-name="mats_type"] input:checked');
      const matType = matTypeElement ? matTypeElement.dataset.name.toLowerCase().replace(/\s+/g, '-') : '';
      // Получение значения рисунка коврика
      let matPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked').dataset.value;
      
  
      // Получение цвета коврика
      const matColor = container.querySelector('.lip__field[data-type="matColor"] input:checked').dataset.value;
  
      // Получение цвета обшивки коврика
      let edgeColor = container.querySelector('.lip__field[data-type="trimColor"] input:checked').dataset.value;
      
      if (edgeColor == 'darkblue') {
        edgeColor = 'blue'
      } else if( edgeColor == 'blue') {
        edgeColor = 'darkblue'
      }

      return { matType, matPattern, matColor, edgeColor };
    }
  
    // Функция для обновления изображения коврика
    function updateMatImage(container) {
      let { matType, matPattern, matColor, edgeColor } = getCurrentOptions(container);
      if (autoType == 'tir' || autoType == 'bus') {
        matPattern = 'diamonds'
      }
      
      // Построение URL изображения
      let imageUrl = `${basePath}${autoType}-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}.webp`;
      console.log({basePath, autoType, matType, matPattern, matColor, edgeColor})

      if (window.innerWidth > 1023) {
        container.querySelectorAll(`.product__config_image--desktop img`).forEach(image => {
          
          image.src = imageUrl;
        })
      } else {
        container.querySelectorAll(`.product__config_image--mobile img`).forEach(image => {
          image.src = imageUrl;
        })
      }
    }

    const typeCustomPrices = {
      noEdge: [450,450,710,550,910],
      withEdge: [550,550,910,550,1210]
    }
    
    const updateLipTitleValue = () => {
    
      lipFields.forEach(field => {
        const inputChecked = field.querySelector('input:checked')
        if (inputChecked) {
          const value = field.querySelector('input:checked').dataset.title;
    
  
          const selectedMatsType = document.querySelector('fieldset[data-name="mats_type"] input:checked');
          const selectedmatsSet = document.querySelector('fieldset[data-name="mats_set"] input:checked');
          const selectedSize = document.querySelector('input[data-name="mats_size"]:checked');
  
          const matsTypeProperty = document.querySelector('[name="properties[MatsType dywaników_]"]')
          const matsSetProperty = document.querySelector('[name="properties[matsSet_]"]')
          const sizeProperty = document.querySelector('[name="properties[Size_]"]')
          
          if (matsTypeProperty) {
            matsTypeProperty.value = selectedMatsType.value
            matsSetProperty.value = selectedmatsSet.value          
          }
          if (sizeProperty) {
            sizeProperty.value = selectedSize.value        
          }
          if (field.querySelector('.lip__title_value')) {
            field.querySelector('.lip__title_value').textContent = value;
          }
      
          if (initialautoType === 'custom') {
            const matsSetField = document.querySelector('fieldset[data-name="mats_set"]')
            const matsSetValue = document.querySelector('fieldset[data-name="mats_set"]').querySelector('input:checked').dataset.title;
            
            
  
            if (selectedMatsType && selectedmatsSet) {
              const matsTypeValue = selectedMatsType.dataset.title;
              const matsSetIndex = Array.from(selectedmatsSet.closest('fieldset').querySelectorAll('input')).indexOf(selectedmatsSet);
              const matsTypeIndex = Array.from(selectedMatsType.closest('fieldset').querySelectorAll('input')).indexOf(selectedMatsType);
      
              let price = null;
              if (matsTypeIndex == 1) {
                price = typeCustomPrices.noEdge[matsSetIndex];
              } else if (matsTypeIndex == 2) {
                price = typeCustomPrices.withEdge[matsSetIndex];
              }
      
              if (matsSetField.querySelector('.lip__title_value') && price !== null) {
                matsSetField.querySelector('.lip__title_value').textContent = `${matsSetValue} ${price} €`;
              }
            }
          }          
        }
      });
    };
  
    // Слушатели изменений для всех опций
    document.querySelectorAll('.product-form__input input[type="radio"], .lip__field input[type="radio"]').forEach((input) => {
      input.addEventListener('change', ()=> {
        const parentContainer = input.closest('.config_container')
        if (input.closest('.lip__field[data-type="matPattern"]') ) {

          if (input.value == 'honeycomb') {
            onlyDiamondsColors.forEach(el => {
              el.classList.add('hidden')
            })
            parentContainer.querySelector('.lip__field[data-type="matColor"] input').checked = true
          } else {
            onlyDiamondsColors.forEach(el => {
              el.classList.remove('hidden')
            })
          }
        }
        updateMatImage(parentContainer)
        updateLipTitleValue()
      });
    });
  
    // Инициализация изображения при загрузке страницы
    if (productContainer) {
      updateMatImage(productContainer);
    }
    if (popupContainer) {
      updateMatImage(popupContainer);
    }
    updateLipTitleValue();
  });

// toggle size product config mobile
(function () {
  const toggler = document.querySelector('.product__config__toggle_size')
  const container = document.querySelector('.sticky_config_price')
  const image = document.querySelector('.product__config_image_image')
  if (toggler) {
    
    toggler.addEventListener('click', () => {
      toggler.classList.toggle('active')
      container.classList.toggle('wide')
      container.removeAttribute('style')
    })
    image.addEventListener('click', () => {
      toggler.classList.toggle('active')
      container.classList.toggle('wide')
      container.removeAttribute('style')
    })
  }
})();
// toggle size product config mobile

// bounce config image mobile after change option
(function () {
  const image = document.querySelector('.sticky_config_price .product__config_image--mobile img')
  const options = document.querySelectorAll('.product__info-wrapper [data-name="mats_type"] input')

  if (image) {
    options.forEach(el => {
      el.addEventListener('change', () => {
        image.classList.add('animate__bounce')
        setTimeout(() => {
          
          image.classList.remove('animate__bounce')
        }, 1000);
      })
    })   
  }
})();
// bounce config image mobile after change option

// product sticky price
(function () {
  const mainPriceElement = document.querySelector('.main_price');
  const stickyConfigPriceElement = document.querySelector('.sticky_config_price');
  const productOptions = document.querySelectorAll('.product-form__input input');

  if (stickyConfigPriceElement && window.innerWidth > 767) {
      // Создаем наблюдатель
      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
          if (!entry.isIntersecting) {
              // Если элемент не виден, добавляем класс active
              stickyConfigPriceElement.classList.add('active');
          } else {
              // Если элемент виден, убираем класс active
              stickyConfigPriceElement.classList.remove('active');
          }
          });
      });
      
      window.addEventListener('load', () => {
          stickyConfigPriceElement.style.width = stickyConfigPriceElement.offsetWidth + 1 + 'px'
      })
      
      // Начинаем наблюдение за основным элементом
      if (mainPriceElement) {
          observer.observe(mainPriceElement);
      }
  } else if (stickyConfigPriceElement) {
    stickyConfigPriceElement.classList.add('active');
  }

})();
// product sticky price


// config steps
(function () {
  const formContainers = document.querySelectorAll('.config_container');

  if (formContainers.length > 0) {

    formContainers.forEach(container => {
      if (!container.querySelector('.product__dropdown_wr')) return;
  
      container.querySelectorAll('fieldset .error-message').forEach(el => {
        el.style.display = 'none';
      });
  
      const faqTitles = container.querySelectorAll('.product__dropdown_title');
      const faqWrappers = container.querySelectorAll('.product__dropdown_wr');
  
      function updateMaxHeight(inner) {
        if (inner.classList.contains("open")) {
          inner.style.maxHeight = inner.scrollHeight + "px";
        } else {
          inner.style.maxHeight = null;
        }
      }
  
      function triggerFaq(element) {
        const wrapper = element.closest('.product__dropdown_wr');
        const inner = wrapper.querySelector('.product__dropdown_inner');
  
        faqWrappers.forEach(w => {
          if (w !== wrapper) {
            w.classList.remove('open');
            const innerOther = w.querySelector('.product__dropdown_inner');
            innerOther.classList.remove('open');
            if (innerOther.classList.contains('super_done')) {
              innerOther.classList.add('done');
            } else {
              innerOther.style.maxHeight = null;
            }
          }
        });
  
        if (wrapper.classList.contains("open")) {
          wrapper.classList.remove("open");
          inner.classList.remove("open");
          if (inner.classList.contains("super_done")) {
            inner.classList.add("done");
          } else {
            inner.style.maxHeight = null;
          }
        } else {
          wrapper.classList.add("open");
          inner.classList.add("open");
          requestAnimationFrame(() => {
            updateMaxHeight(inner);
          });
          inner.classList.remove("done");
        }
      }
  
      faqTitles.forEach(title => {
        title.addEventListener('click', function () {
          triggerFaq(this);
        });
      });
  
      function validateStep(wrapper, showErrors = false) {
        let stepValid = true;
        const processedRadioGroups = new Set();
        const requiredElements = wrapper.querySelectorAll('input[required], select[required], textarea[required]');
  
        requiredElements.forEach(element => {
          if (!element.offsetParent) return;
          let valid = true;
          if (element.type === 'radio') {
            if (processedRadioGroups.has(element.name)) return;
            processedRadioGroups.add(element.name);
            const radios = wrapper.querySelectorAll(`input[type="radio"][name="${element.name}"]`);
            let groupValid = false;
            radios.forEach(radio => {
              if (radio.checked) groupValid = true;
            });
            valid = groupValid;
          } else if (element.type === 'checkbox') {
            valid = element.checked;
          } else {
            valid = element.value.trim() !== '';
          }
          const fieldset = element.closest('fieldset');
          if (!valid) {
            stepValid = false;
            if (showErrors && fieldset) {
              const errorMessage = fieldset.querySelector('.error-message');
              if (errorMessage) {
                errorMessage.style.display = 'block';
              }
            }
          } else {
            if (showErrors && fieldset) {
              const errorMessage = fieldset.querySelector('.error-message');
              if (errorMessage) {
                errorMessage.style.display = 'none';
              }
            }
          }
        });
        return stepValid;
      }
      function updateContinueButton(wrapper) {
        const continueBtn = wrapper.querySelector('.product__dropdown_button');
        if (!continueBtn) return;
  
        const requiredFields = wrapper.querySelectorAll('input[required], textarea[required]');
        let isValid = true;
  
        requiredFields.forEach(field => {
          if (!field.value.trim()) {
            isValid = false;
          }
        });
  
        continueBtn.disabled = !isValid;
        continueBtn.classList.toggle('disabled-button', !isValid);
      }
  
      function goToNextStep() {
        const currentStep = document.querySelector('.product__dropdown_wr.active');
        if (!currentStep) return;
  
        const continueBtn = currentStep.querySelector('.product__dropdown_button');
        if (continueBtn && continueBtn.disabled) return;
  
        currentStep.classList.remove('active');
        const nextStep = currentStep.nextElementSibling;
        if (nextStep) {
          nextStep.classList.add('active');
          updateContinueButton(nextStep);
        }
      }
  
      document.querySelectorAll('.product__dropdown_wr').forEach(wrapper => {
        updateContinueButton(wrapper);
      });
  
      faqWrappers.forEach(wrapper => {
        updateContinueButton(wrapper);
      });
  
      document.querySelectorAll('.product__dropdown_inner input, .product__dropdown_inner textarea').forEach(element => {
        element.addEventListener('input', function () {
          const wrapper = this.closest('.product__dropdown_wr');
          updateContinueButton(wrapper);
        });
      });
  
      function revalidate(e) {
        const wrapper = e.target.closest('.product__dropdown_wr');
        const inner = wrapper.querySelector('.product__dropdown_inner');
  
        const isValid = validateStep(wrapper, false);
  
        if (!isValid) {
          inner.classList.remove('super_done');
          setFollowingStepsDisabled(wrapper, true);
        }
  
        updateContinueButton(wrapper);
        if (container.querySelector('.application_form__next_button')) {
          updateNextButtonState(container);          
        }
      }
  
      faqWrappers.forEach(wrapper => {
        const requiredEls = wrapper.querySelectorAll('input[required], select[required], textarea[required]');
        const continueBtn = wrapper.querySelector('.product__dropdown_button');
        if (!continueBtn) return;
        updateContinueButton(wrapper);
        requiredEls.forEach(el => {
          el.addEventListener('input', revalidate);
          el.addEventListener('change', revalidate);
        });
      });
  
      const dropdownsButton = container.querySelectorAll('.product__dropdown_button');
  
      dropdownsButton.forEach(button => {
        button.addEventListener('click', function () {
          const wrapper = button.closest('.product__dropdown_wr');
          const inner = wrapper.querySelector('.product__dropdown_inner');
  
          requestAnimationFrame(() => {
            updateMaxHeight(inner);
          });
  
          if (!validateStep(wrapper, true)) {
            updateContinueButton(wrapper);
            requestAnimationFrame(() => {
              updateMaxHeight(inner);
            });
            return;
          }
  
          wrapper.querySelectorAll('.error-message').forEach(el => {
            el.style.display = 'none';
          });
  
          wrapper.classList.remove('open');
          inner.classList.remove('open');
          inner.classList.add('done', 'super_done');
          requestAnimationFrame(() => {
            inner.style.maxHeight = inner.scrollHeight + "px";
          });
  
          const nextWrapper = getNextDropdown(wrapper);
          if (nextWrapper) {
            nextWrapper.classList.add('open');
            nextWrapper.classList.remove('disabled');
            nextWrapper.querySelector('.product__dropdown_inner').classList.remove('done');
            console.log(nextWrapper)
            const nextInner = nextWrapper.querySelector('.product__dropdown_inner');
            nextInner.classList.add('open');
            setTimeout(() => {
              nextInner.style.maxHeight = nextInner.scrollHeight + "px";
            }, 10);
  
            const nextTitle = nextWrapper.querySelector('.product__dropdown_title');
            const popup = document.querySelector('#popupOverlayApplicationForm');
            const isInsidePopup = wrapper.closest('.popup');
  
            setTimeout(() => {
              if (nextTitle) {
                if (isInsidePopup) {
                  popup.scrollTo({
                    top: nextTitle.offsetTop - 20,
                    behavior: 'smooth'
                  });
                } else {
                  const topOffset = nextTitle.getBoundingClientRect().top + window.scrollY - 150;
                  window.scrollTo({ top: topOffset, behavior: 'smooth' });
                }
              }
            }, 300);
          }
  
          if (container.querySelector('.application_form__next_button')) {
            updateNextButtonState(container);          
          }
          goToNextStep();  // Переход к следующему шагу
        });
      });
  
      function getNextDropdown(current) {
        let next = current.nextElementSibling;
        while (next) {
          if (next.classList.contains('product__dropdown_wr')) {
            next.classList.remove('disabled');
            return next;
          }
          next = next.nextElementSibling;
        }
        return null;
      }
  
      faqWrappers.forEach((wrapper, i) => {
        const title = wrapper.querySelector('.product__dropdown_title');
        title.innerHTML = `${i + 1}. ${title.innerHTML}`;
        if (i === 0) {
          wrapper.classList.add('open');
          wrapper.querySelector('.product__dropdown_inner').classList.add('open');
          wrapper.classList.remove('disabled');
        }
      });
  
      function updateNextButtonState(container) {
        if (!container) {
          console.error("Container not found!");
          return;
        }
  
        const steps = container.querySelectorAll('.product__dropdown_wr');
        const nextButton = container.querySelector('.application_form__next_button');
  
        if (!steps || steps.length === 0) {
          console.error("No steps found in the container!");
          return;
        }
  
        let allCompleted = true;
        steps.forEach(step => {
          if (step.classList.contains('product__dropdown_wr--heel')) {
            return;
          }
          if (!step.querySelector('.product__dropdown_button')) {
            return;
          }
  
          const inner = step.querySelector('.product__dropdown_inner');
          if (!inner || !inner.classList.contains('super_done')) {
            allCompleted = false;
          }
        });
  
        if (nextButton) {
          if (allCompleted) {
            nextButton.disabled = false;
            nextButton.classList.remove('disabled-button');
          } else {
            nextButton.disabled = true;
            nextButton.classList.add('disabled-button');
          }
        } else {
          console.error("Next button not found!");
        }
      }
  
      function setFollowingStepsDisabled(currentWrapper, disabled) {
        let next = currentWrapper.nextElementSibling;
        while (next) {
          if (next.classList.contains('product__dropdown_wr')) {
            if (disabled) {
              next.classList.add('disabled');
              // next.querySelector('.product__dropdown_inner').classList.remove('done')
            } else {
              next.classList.remove('disabled');
              
            }
          }
          next = next.nextElementSibling;
        }
      }
    });
  
    
  
      
    const yearSelect = document.querySelector('[data-dropdown="year"] .select__select');
    if (yearSelect) {
      yearSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const selectedValue = selectedOption.value;
        const yearProperty = yearSelect.closest('.product__dropdown_wr').querySelector('.product__dropdown_value');
        if (yearProperty) {
          yearProperty.textContent = selectedValue;
        }
      });
    }
  }
})();


// config steps


(function () {
  const valueFields = document.querySelectorAll('.lip__field');
  if (valueFields) {
    valueFields.forEach(field => {
      const inputs = field.querySelectorAll('input');
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          const value = input.value;
          field.querySelector('.lip__title_value').textContent = value;
        });
      });
    });
  }
})();


// toggle class in upsell item
(function () {
  const inputs = document.querySelectorAll('input[name="product__upsell"]')

  inputs.forEach(input => {
    input.addEventListener('change', () => {
      const upsellItem = input.closest('.product__upsell_item')
      if (input.checked) {
        upsellItem.classList.add('active')
      } else {
        upsellItem.classList.remove('active')
      }
    })
  })
})();
// toggle class in upsell item